'use client';

import { useTranslations } from 'next-intl';
import { FAQ, type FAQItem } from '@/app/components/ui/FAQ';
import { Link } from '@/i18n/routing';

export function QuestionSection() {
  const t = useTranslations('ai-image-to-video');

  // 动态创建 FAQ 问题数据
  const faqItems: FAQItem[] = (['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const).map((key, index) => {
    const description = t(`faq.${key}.description`);

    // 为 q1 添加 Reference to Video 链接
    if (key === 'q1') {
      return {
        id: `faq-${index + 1}`,
        question: t(`faq.${key}.title`),
        answer: [
          {
            title: `${description} Need multi-reference videos? `,
            link: (
              <Link href="/ai-reference-to-video" className="text-[#0086FF] hover:underline">
                Try Reference to Video
              </Link>
            ),
          },
        ],
      };
    }

    // 为 q6 添加 Text to Video 链接
    if (key === 'q6') {
      return {
        id: `faq-${index + 1}`,
        question: t(`faq.${key}.title`),
        answer: [
          {
            title: `${description} Don't have an image? `,
            link: (
              <Link href="/ai-text-to-video" className="text-[#0086FF] hover:underline">
                Start from a text prompt
              </Link>
            ),
          },
        ],
      };
    }

    return {
      id: `faq-${index + 1}`,
      question: t(`faq.${key}.title`),
      answer: [{ title: description }],
    };
  });

  return (
    <section className="bg-black">
      <div className="mx-auto">
        <FAQ items={faqItems} title={t('faq.title')} customTopMargin="mt-20" customBottomMargin="mb-20" />
      </div>
    </section>
  );
}
